
import { defineComponent } from 'vue'
import AuthModule from '../../store/auth.module'
import serverinforesponse from '@/model/response/serverinforesponse'
import { useI18n } from 'vue-i18n'
import response from '@/model/response'
import message from '@/model/message'

export default defineComponent({
  name: 'ServerInfo',

  setup() {
    const { t } = useI18n({ useScope: 'global' })
    return { t }
  },

  data() {
    return {
      info: {} as serverinforesponse,
      loading: false,
      error: false,
    }
  },

  mounted(): void {
    this.loading = true
    this.error = false

    AuthModule.ServerInfo().then(
      (resp: response) => {
        console.log(resp)

        if (resp.statusCodeValue === 200) {
          const msg = (resp.body as message).message
          this.info = JSON.parse(msg)
        }

        this.loading = false
      },
      (error) => {
        console.error(error)
        this.error = true
        this.loading = false
      }
    )
  }
})
